'use strict';
(() => {
  const menu = document.querySelector('.gt-menu');
  const nav = document.getElementById('gt-navigation');
  if (menu && nav) {
    menu.addEventListener('click', () => {
      const expanded = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(expanded));
      nav.classList.toggle('open', expanded);
    });
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      nav.classList.remove('open');
      menu.setAttribute('aria-expanded', 'false');
    }));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && nav.classList.contains('open')) {
        nav.classList.remove('open');
        menu.setAttribute('aria-expanded', 'false');
        menu.focus();
      }
    });
  }

  // Respect the store's configured visitor permissions; never override consent choices.
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {});
  }
  function analyticsAllowed() {
    return !window.Shopify || window.Shopify.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }
  // No contact details, form values, alarm coordinates or message contents enter analytics.
  function track(interaction, placement = '') {
    if (!analyticsAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'gothermal_fibre_interaction', interaction, placement, solution: 'fibre_intrusion_detection'});
  }
  document.querySelectorAll('[data-gt-event]').forEach(element => {
    element.addEventListener('click', () => track(element.dataset.gtEvent, element.dataset.gtPlacement || 'page'));
  });

  const stages = [
    ['01 / Detect the disturbance', 'A configured sensing installation detects an intrusion, digging or pipeline-tampering event along the protected asset.'],
    ['02 / Locate the alarm', 'The event is related to the commissioned site map. Location information depends on the selected sensing architecture and installation.'],
    ['03 / Classify and share', 'Live event coordinates and an alarm classification pass through the SDK to connected security and response systems.'],
    ['04 / Direct the approved response', 'The FlightHub 2 workflow directs a Dock-based aircraft towards the reported incident location, after the required operational, readiness and flight-permission checks.'],
    ['05 / Verify, deter and coordinate', 'Use a suitable visual or thermal aircraft to assess the scene. Supported spotlight or speaker payloads, where fitted and authorised, can assist deterrence and ground-team coordination.']
  ];
  const mission = document.querySelector('.gt-mission');
  document.querySelectorAll('[data-gt-stage]').forEach(button => {
    button.addEventListener('click', () => {
      const n = Number(button.dataset.gtStage);
      if (!stages[n] || !mission) return;
      mission.dataset.stage = String(n);
      document.getElementById('gt-stage-title').textContent = stages[n][0];
      document.getElementById('gt-stage-description').textContent = stages[n][1];
      document.querySelectorAll('[data-gt-stage]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      track('response_stage', String(n + 1));
    });
  });

  // Use the same verified GoThermal form as the live contact page. No custom API credentials.
  const formButton = document.getElementById('gt-load-form');
  const status = document.getElementById('gt-form-status');
  const host = document.getElementById('gt-hubspot');
  let loading = false;
  let ready = false;
  let attempt = 0;
  let timer;
  function failForm(id) {
    if (id !== attempt || ready) return;
    attempt += 1;
    clearTimeout(timer);
    loading = false;
    host.replaceChildren();
    host.hidden = true;
    document.getElementById('gt-form-intro').hidden = false;
    formButton.disabled = false;
    formButton.textContent = 'Retry loading the enquiry form';
    status.textContent = 'The form service could not be loaded. Retry, use the contact-page link, or email/call us. No enquiry has been submitted.';
  }
  function createForm(id) {
    if (id !== attempt || ready) return;
    if (!window.hbspt || !window.hbspt.forms) { failForm(id); return; }
    // An isolated target prevents late embeds from populating a newer attempt.
    const target = document.createElement('div');
    target.id = `gt-hubspot-attempt-${id}`;
    host.replaceChildren(target);
    host.hidden = false;
    try { window.hbspt.forms.create({
      portalId: '9311151',
      formId: 'aa9dfe43-a432-4892-8135-1aab54fba146',
      target: `#${target.id}`,
      onFormReady: () => {
        if (id !== attempt) return;
        clearTimeout(timer);
        loading = false;
        ready = true;
        document.getElementById('gt-form-intro').hidden = true;
        status.textContent = '';
        const iframe = host.querySelector('iframe');
        if (iframe) iframe.title = 'GoThermal site assessment enquiry form';

      },
      onFormSubmitted: () => {
        if (id !== attempt || !ready) return;
        if (analyticsAllowed()) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({event: 'generate_lead', solution: 'fibre_intrusion_detection', method: 'hubspot_form'});
        }
        status.textContent = 'Your enquiry has been submitted through the GoThermal form.';
      }
    }); } catch (_) { failForm(id); }
  }
  function loadForm() {
    if (loading) return;
    if (ready) { host.hidden = false; return; }
    const id = ++attempt;
    loading = true;
    formButton.disabled = true;
    formButton.textContent = 'Loading enquiry form…';
    status.textContent = 'Connecting to GoThermal’s HubSpot form service…';
    timer = setTimeout(() => failForm(id), 20000);
    if (window.hbspt && window.hbspt.forms) { createForm(id); return; }
    const previous = document.getElementById('gt-hubspot-script');
    if (previous) previous.remove();
    const script = document.createElement('script');
    script.id = 'gt-hubspot-script';
    script.src = 'https://js.hsforms.net/forms/shell.js';
    script.async = true;
    script.onload = () => createForm(id);
    script.onerror = () => failForm(id);
    document.head.appendChild(script);
  }
  if (formButton && host) {
    formButton.addEventListener('click', loadForm);
    loadForm();
  }
})();
